var Handlebars = require('/data/wordpress/wp-content/themes/freepik-blog/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"countdown\"></div>";
},"useData":true});